import { render, staticRenderFns } from "./QueuesDashboard.vue?vue&type=template&id=58005488&scoped=true"
import script from "./QueuesDashboard.vue?vue&type=script&lang=js"
export * from "./QueuesDashboard.vue?vue&type=script&lang=js"
import style0 from "./QueuesDashboard.vue?vue&type=style&index=0&id=58005488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58005488",
  null
  
)

export default component.exports